module.exports = __webpack_public_path__ + "static/media/ananas.5669fca5.svg";